import { SUPPLIER_REQUEST_STATUS } from '../../model/constants';
import type { StatusOption } from './types';

type TranslateFn = (key: string) => string;

export const toStatusOptions = (t: TranslateFn): StatusOption[] => [
    { value: SUPPLIER_REQUEST_STATUS.ACTIVE, label: t('supplierRequests.status.active') },
    { value: SUPPLIER_REQUEST_STATUS.DONE, label: t('supplierRequests.status.done') },
    { value: SUPPLIER_REQUEST_STATUS.DELETED, label: t('supplierRequests.status.deleted') },
];
